import { useState, useRef } from 'react'
import Lottie from 'react-lottie'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import watsonAssistant from '../../../utils/watson-assistant'
import yamahaLogo from '../../../assets/yamaha-logo.png'
import blueprintSoundSystem from '../../../assets/blueprint-sound-system.svg'
import * as animationData from '../../../assets/animations/hotspot.json'
import './styles.scss'

const YAMAHA_TABS = {
  ULTIMATE: 'ultimate',
  PREMIUM: 'premium',
}

const YAMAHA_ULTIMATE_DOTS = [
  {
    top: 106,
    left: 82,
    label: 'blueprint.soundSystem.hotspot-1.label',
    message: 'blueprint.soundSystem.hotspot-1.message',
    position: 'bottom',
  },
  {
    top: 145,
    left: 175,
    label: 'blueprint.soundSystem.hotspot-2.label',
    message: 'blueprint.soundSystem.hotspot-2.message',
    position: 'right',
  },
  {
    top: 355,
    left: 175,
    label: 'blueprint.soundSystem.hotspot-2.label',
    message: 'blueprint.soundSystem.hotspot-2.message',
    position: 'right',
  },
  {
    top: 240,
    left: 0,
    label: 'blueprint.soundSystem.hotspot-3.label',
    message: 'blueprint.soundSystem.hotspot-3.message',
    position: 'left',
  },
  {
    top: 400,
    left: 0,
    label: 'blueprint.soundSystem.hotspot-3.label',
    message: 'blueprint.soundSystem.hotspot-3.message',
    position: 'left',
  },
  {
    top: 560,
    left: 40,
    label: 'blueprint.soundSystem.hotspot-4.label',
    message: 'blueprint.soundSystem.hotspot-4.message',
    position: 'left',
  },
]

const YAMAHA_PREMIUM_DOTS = [
  {
    top: 145,
    left: 175,
    label: 'blueprint.soundSystem.hotspot-2.label',
    message: 'blueprint.soundSystem.hotspot-2.message',
    position: 'right',
  },
  {
    top: 355,
    left: 175,
    label: 'blueprint.soundSystem.hotspot-2.label',
    message: 'blueprint.soundSystem.hotspot-2.message',
    position: 'right',
  },
  {
    top: 240,
    left: 0,
    label: 'blueprint.soundSystem.hotspot-3.label',
    message: 'blueprint.soundSystem.hotspot-3.message',
    position: 'left',
  },
  {
    top: 400,
    left: 0,
    label: 'blueprint.soundSystem.hotspot-3.label',
    message: 'blueprint.soundSystem.hotspot-3.message',
    position: 'left',
  },
]

function SoundSystem() {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(YAMAHA_TABS.ULTIMATE)
  const containerRef = useRef(null)

  const activeDots = activeTab === YAMAHA_TABS.ULTIMATE ? YAMAHA_ULTIMATE_DOTS : YAMAHA_PREMIUM_DOTS

  return (
    <div className="Blueprint">
      <p className="Blueprint__Question">{t('blueprint.soundSystem.question')}</p>
      <div className="Blueprint__YamahaTabs">
        <button
          className={classNames({
            'yamaha-btn': true,
            'yamaha-btn--active': activeTab === YAMAHA_TABS.ULTIMATE,
          })}
          onClick={() => setActiveTab(YAMAHA_TABS.ULTIMATE)}
          disabled={activeTab === YAMAHA_TABS.ULTIMATE}
        >
          {t('blueprint.soundSystem.yamahaUltimate')}
        </button>
        <button
          className={classNames({
            'yamaha-btn': true,
            'yamaha-btn--active': activeTab === YAMAHA_TABS.PREMIUM,
          })}
          onClick={() => setActiveTab(YAMAHA_TABS.PREMIUM)}
          disabled={activeTab === YAMAHA_TABS.PREMIUM}
        >
          {t('blueprint.soundSystem.yamahaPremium')}
        </button>
      </div>
      <div
        className="Blueprint__Container"
        ref={containerRef}
      >
        <div className="Blueprint__Description">
          {activeTab === YAMAHA_TABS.ULTIMATE ? (
            <>
              <p className="uppercase">{t('blueprint.soundSystem.includedIn')}</p>
              <p>{t('blueprint.soundSystem.includedInUltimate')}</p>
            </>
          ) : (
            <>
              <p className="uppercase">{t('blueprint.soundSystem.includedIn')}</p>
              <p>{t('blueprint.soundSystem.includedInPremium')}</p>
            </>
          )}
          <img
            className="Blueprint__YamahaLogo"
            src={yamahaLogo}
            alt="Yamaha logo"
          />
        </div>
        <div className="Blueprint__ImageContainer">
          <img
            className="Blueprint__Background"
            src={blueprintSoundSystem}
            alt="Blueprint audio system"
          />
          {activeDots.map((dot, index) => (
            <div
              key={index}
              className={classNames({
                Blueprint__DotContainer: true,
                [`Blueprint__position-${dot.position}`]: true,
              })}
              style={{ top: dot.top, left: dot.left }}
              onClick={() => {
                watsonAssistant.getInstance().sendMessageHotspot(t(dot.message))
              }}
            >
              <div className="Blueprint__Label">{t(dot.label)}</div>
              <div
                className={classNames({
                  Blueprint__LottieDot: true,
                  [`Blueprint__dot-position-${dot.position}`]: true,
                })}
              >
                <Lottie
                  isClickToPauseDisabled
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: animationData,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SoundSystem
